import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigationProps {
  isDark: boolean;
  setIsDark: (isDark: boolean) => void;
}

const Navigation: React.FC<NavigationProps> = ({ isDark, setIsDark }) => {
  const location = useLocation();

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 ${isDark ? 'bg-gray-900/95' : 'bg-white/95'} backdrop-blur-sm border-b ${isDark ? 'border-gray-800' : 'border-gray-200'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent">
            shmeevee
          </Link>
          
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className={`transition-colors ${
                location.pathname === '/' 
                  ? 'text-cyan-500' 
                  : isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Home
            </Link>
            <Link
              to="/blog"
              className={`transition-colors ${
                location.pathname === '/blog' 
                  ? 'text-cyan-500' 
                  : isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Blog
            </Link>
            
            <button
              onClick={() => setIsDark(!isDark)}
              className={`p-2 rounded-lg ${isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}
            >
              {isDark ? '☀️' : '🌙'}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;